document.addEventListener('DOMContentLoaded', function () {
  initFaqAccordion();
  initMobileNav();
  initAddToCart();
  initQuantitySelectors();
  initCartRemove();
  initCartAutoUpdate();
  initProductGallery();
});

/* ── FAQ accordion ── */
function initFaqAccordion() {
  document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.faq-item');
      var wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (el) {
        el.classList.remove('open');
      });
      if (!wasOpen) item.classList.add('open');
    });
  });
}

/* ── Mobile nav ── */
function initMobileNav() {
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', function () {
    var isOpen = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
  });
  nav.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
  });
}

/* ── Add to cart (AJAX) ── */
function initAddToCart() {
  document.body.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('.product-card-form-el, [data-product-form]')) return;

    event.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Añadiendo...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: form.querySelector('[name="id"]').value,
        quantity: form.querySelector('[name="quantity"]') ? form.querySelector('[name="quantity"]').value : 1
      })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (item) {
        updateCartCount();
        showCartNotification(item.title + ' añadido al carrito');
      })
      .catch(function (err) {
        showCartNotification((err && err.description) || 'No se pudo añadir el producto.');
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      });
  });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    });
}

function showCartNotification(message) {
  var el = document.getElementById('cart-notification');
  if (!el) return;
  el.textContent = message;
  el.classList.add('is-visible');
  clearTimeout(showCartNotification._t);
  showCartNotification._t = setTimeout(function () {
    el.classList.remove('is-visible');
  }, 3000);
}

/* ── Cart line item removal ── */
function initCartRemove() {
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-cart-remove');
      var form = btn.closest('form');
      if (!form) return;
      var input = form.querySelector('input[name="updates[' + key + ']"]');
      if (input) input.value = 0;
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });
}

/* — Cart auto-update on quantity change — */
function initCartAutoUpdate() {
  document.querySelectorAll('.cart-table input[name^="updates"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (!form) return;
              var updateBtn = form.querySelector('button[name="update"]');
        if (form.requestSubmit) { form.requestSubmit(updateBtn || undefined); } else { form.submit(); }
    });
  });
}

/* ── Quantity selectors (product / cart pages) ── */
function initQuantitySelectors() {
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    wrap.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = (parseInt(input.value, 10) || 1) + 1;
        input.value = value;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
}


/* — Product gallery (thumbnails, swipe, zoom) — */
function initProductGallery() {
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    var images = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-image]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var current = 0;

    function showImage(index) {
      if (index < 0) index = images.length - 1;
      if (index >= images.length) index = 0;
      current = index;
      images.forEach(function (img, i) {
        img.style.display = i === index ? '' : 'none';
        img.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showImage(parseInt(thumb.getAttribute('data-index'), 10) || 0);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { showImage(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showImage(current + 1); });

    if (!main) return;

    /* Desktop: hover-follow zoom */
    main.addEventListener('mousemove', function (e) {
      var rect = main.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      var activeImg = main.querySelector('[data-gallery-image].is-active');
      if (activeImg) activeImg.style.transformOrigin = x + '% ' + y + '%';
      main.classList.add('is-zoomed');
    });
    main.addEventListener('mouseleave', function () {
      main.classList.remove('is-zoomed');
    });

    /* Touch: slow drag zooms/pans, quick flick swaps image */
    var touchStartX = 0, touchStartY = 0, touchStartTime = 0, isTouching = false;

    main.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchStartTime = Date.now();
      isTouching = true;
    }, { passive: true });

    main.addEventListener('touchmove', function (e) {
      if (!isTouching || !e.touches || !e.touches.length) return;
      var touch = e.touches[0];
      var dx = Math.abs(touch.clientX - touchStartX);
      var dy = Math.abs(touch.clientY - touchStartY);
      if (dx < 40 || dy > dx) {
        var rect = main.getBoundingClientRect();
        var x = ((touch.clientX - rect.left) / rect.width) * 100;
        var y = ((touch.clientY - rect.top) / rect.height) * 100;
        var activeImg = main.querySelector('[data-gallery-image].is-active');
        if (activeImg) activeImg.style.transformOrigin = x + '% ' + y + '%';
        main.classList.add('is-zoomed');
      }
    }, { passive: true });

    main.addEventListener('touchend', function (e) {
      isTouching = false;
      main.classList.remove('is-zoomed');
      var touch = e.changedTouches && e.changedTouches[0];
      if (!touch) return;
      var dx = touch.clientX - touchStartX;
      var dy = touch.clientY - touchStartY;
      var dt = Date.now() - touchStartTime;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && dt < 600) {
        showImage(current + (dx < 0 ? 1 : -1));
      }
    });
  });
}
